import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UsuarioEditarComponent } from './usuario-editar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: UsuarioEditarComponent }
    ])],
    exports: [RouterModule]
})
export class UsuarioEditarRoutingModule { }
